import { Map } from 'immutable';

import { CapabilitiesActions, CapabilitiesStateKeys } from '../constants/Capabilities';
import { createReducer } from '../lib/ReducerUtils';

const INITIAL_STATE = Map({
  [CapabilitiesStateKeys.IS_MOBILE]: false,
  [CapabilitiesStateKeys.IS_TABLET]: false,
});

// BROWSEGENRES REDUCER
export default createReducer(INITIAL_STATE, {
  [CapabilitiesActions.SET_CAPABILITIES]: setCapabilities,
});

// CASE FUNCTIONS

function setCapabilities(state, action) {
  return state.merge({
    [CapabilitiesStateKeys.IS_MOBILE]: action.data.isMobile,
    [CapabilitiesStateKeys.IS_TABLET]: action.data.isTablet,
  });
}
